import ForgotPasswordBody from "@/components/landing/auth/ForgotPasswordTwoBody";

export default function ForgotPassword2Page() {
  return <ForgotPasswordBody />;
}
